export const EVENT_TYPES = {
  campaignsUpserted: "campaigns:upserted",
  campaignsRemoteCreateFailed: "campaigns:remote-create:failed",
  campaignsRemoteUpdateFailed: "campaigns:remote-update:failed",
  campaignsRemoteBudgetUpdateFailed: "campaigns:remote-budget-update:failed",
  campaignsRemoteRemoveFailed: "campaigns:remote-remove:failed",
  campaignsRemotePauseFailed: "campaigns:remote-pause:failed",
  integrationsCompanyRegistered: "integrations:company-registered",
} as const;

export const REMOTE_FAILURE_EVENT_TYPES = [
  EVENT_TYPES.campaignsRemoteCreateFailed,
  EVENT_TYPES.campaignsRemoteUpdateFailed,
  EVENT_TYPES.campaignsRemoteBudgetUpdateFailed,
  EVENT_TYPES.campaignsRemoteRemoveFailed,
  EVENT_TYPES.campaignsRemotePauseFailed,
] as const;

export type EventType = (typeof EVENT_TYPES)[keyof typeof EVENT_TYPES];

export type RemoteFailureEventType = (typeof REMOTE_FAILURE_EVENT_TYPES)[number];

const EVENT_TYPE_SEPARATOR = ":";

export const FAILED_OUTCOME = "failed";

export function parseEventType(eventType: string) {
  const [domain = "", , outcome = ""] = eventType.split(EVENT_TYPE_SEPARATOR);
  return { domain, outcome };
}
